import { SliderDirection } from '@/react/components/Slider/ISliderOptions';
import { Input } from '@builder.io/sdk';

/**
 * The Arrow Variant enum.
 */
export enum ArrowVariant {
  Angle = 'angle',
  AngleLight = 'angleLight',
  Arrow = 'arrow',
  Caret = 'caret',
  ArrowLight = 'arrowLight'
}

export const sliderSettingsDefaultValues = {
  slidesPerView: 1,
  mobileSlidesPerView: 1,
  height: 'auto',
  loop: false,
  slideDirection: SliderDirection.Horizontal,
  centeredSlides: false,
  autoplayDelayMS: 5000,
  transitionSpeedMS: 600,
  watchOverflow: true,
  navigationEnabled: false,
  navigationOptions: { inset: false, arrowVariant: ArrowVariant.Arrow },
  pagination: {
    enabled: true,
    inset: false,
    direction: SliderDirection.Horizontal,
    clickable: true
  }
};

export const sliderSettings = {
  name: 'sliderSettings',
  type: 'object',
  defaultValue: sliderSettingsDefaultValues,
  subFields: [
    { name: 'slidesPerView', type: 'number', defaultValue: 1 },
    { name: 'mobileSlidesPerView', type: 'number', defaultValue: 1 },
    { name: 'autoplay', type: 'boolean', defaultValue: false },
    { name: 'spaceBetween', type: 'number', defaultValue: 0 },
    {
      name: 'height',
      type: 'text',
      enum: ['auto', '100%', '50vh'],
      defaultValue: 'auto'
    },
    { name: 'loop', type: 'boolean', defaultValue: false },
    { name: 'autoplayDelayMS', type: 'number', defaultValue: 5000 },
    { name: 'transitionSpeedMS', type: 'number', defaultValue: 600 },
    {
      name: 'slideDirection',
      type: 'text',
      defaultValue: SliderDirection.Horizontal,
      enum: [SliderDirection.Horizontal, SliderDirection.Vertical]
    },
    { name: 'centeredSlides', type: 'boolean', defaultValue: false },
    { name: 'watchOverflow', type: 'boolean', defaultValue: true },
    { name: 'navigationEnabled', type: 'boolean', defaultValue: false },
    {
      name: 'navigationOptions',
      type: 'object',
      subFields: [
        { name: 'inset', type: 'boolean', defaultValue: false },
        {
          name: 'arrowVariant',
          type: 'text',
          defaultValue: ArrowVariant.Arrow,
          enum: Object.values(ArrowVariant).map((value) => {
            return value;
          })
        }
      ]
    },
    {
      name: 'pagination',
      type: 'object',
      advanced: true,
      subFields: [
        { name: 'enabled', type: 'boolean', defaultValue: false },
        { name: 'inset', type: 'boolean', defaultValue: false },
        {
          name: 'direction',
          type: 'text',
          defaultValue: SliderDirection.Horizontal,
          enum: [SliderDirection.Horizontal, SliderDirection.Vertical]
        },
        { name: 'clickable', type: 'boolean', defaultValue: true }
      ]
    }
  ]
} satisfies Input;
